import { AxiosInstance } from 'axios';
import RedisApiAxiosInstance from 'services/api/RedisApiAxiosInstance/RedisApiAxiosInstance';
import { loadRemoteModule } from 'moduleFederation/moduleFederationRuntime';
import { Config } from '../../config';

type InitApiService = (axiosInstance: AxiosInstance, baseUrl: string | false) => void;

const initIntegrationsMFEApiService = async () => {
  try {
    const { initCloudIntegrationApiService, initSmApiService } = await loadRemoteModule<{
      initCloudIntegrationApiService: InitApiService;
      initSmApiService: InitApiService;
    }>('integrations/initApiService');
    initSmApiService?.(RedisApiAxiosInstance, !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.SM);
    initCloudIntegrationApiService?.(
      RedisApiAxiosInstance,
      !Config.IS_RELATIVE_API && Config.CURRENT_ORIGINS.CLOUD_INTEGRATION
    );
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error('cannot load initIntegrationsMFEApiService', e);
  }
};

export default initIntegrationsMFEApiService;
